module.exports = __webpack_public_path__ + "static/dslogos.631e9267.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dslogos.png
// module id = 408
// module chunks = 65579394461380